import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { UsersFilterOptions } from '../../api/get-users-filter-options/getUsersFilterOptions.types';

import { getUsersFilterOptions } from '../../api/get-users-filter-options/getUsersFilterOptions';

export function useUsersFilterOptions(
  organizationId: string
): UseQueryResult<UsersFilterOptions, Error> {
  return useQuery<UsersFilterOptions, Error>({
    queryKey: ['users', 'filter-options', organizationId],
    queryFn: (): Promise<UsersFilterOptions> =>
      getUsersFilterOptions(organizationId),
    enabled: !!organizationId,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
